<template>
  <div id="settings-tenant" class="settings-container">
    <!-- Header com botão de voltar -->
    <div class="settings-header">
      <v-btn
        icon
        small
        @click="$router.back()"
        class="back-button"
      >
        <v-icon color="grey darken-3">mdi-arrow-left</v-icon>
      </v-btn>
    </div>

    <!-- Card centralizado -->
    <v-card
      id="settings-card"
      class="settings-card"
      elevation="0"
      outlined
    >
      <v-card-title class="justify-center pt-8 pb-4">
        <div class="text-center">
          <v-avatar color="blue lighten-4" size="56" class="mb-4">
            <v-icon color="blue darken-2" size="32">mdi-domain</v-icon>
          </v-avatar>
          <div class="text-h5 font-weight-bold mt-4">Tenant</div>
          <div class="text-caption grey--text mt-1">Configurar o tenant administrativo do sistema</div>
        </div>
      </v-card-title>

      <v-card-text class="pa-6">
        <!-- Aviso de desenvolvimento -->
        <v-alert
          type="warning"
          text
          icon="mdi-alert"
          class="mb-4"
        >
          <strong>Em Desenvolvimento:</strong> Esta funcionalidade ainda não está conectada ao backend.
        </v-alert>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
          class="form-container"
        >
          <h3 class="text-h6 mb-4">Dados da Empresa</h3>

          <div class="form-field">
            <v-text-field
              v-model="tenantData.razaoSocial"
              label="Razão Social *"
              :rules="[v => !!v || 'Campo obrigatório']"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-text-field
              v-model="tenantData.nomeFantasia"
              label="Nome Fantasia *"
              :rules="[v => !!v || 'Campo obrigatório']"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-text-field
              v-model="tenantData.cnpj"
              label="CNPJ *"
              :rules="[v => !!v || 'Campo obrigatório']"
              placeholder="00.000.000/0000-00"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-select
              v-model="tenantData.setor"
              :items="setores"
              label="Setor *"
              :rules="[v => !!v || 'Campo obrigatório']"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-text-field
              v-model="tenantData.telefone"
              label="Telefone"
              placeholder="(00) 00000-0000"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-text-field
              v-model="tenantData.website"
              label="Website"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-select
              v-model="tenantData.porteEmpresa"
              :items="portesEmpresa"
              label="Porte da Empresa"
              outlined
              dense
            />
          </div>

          <div class="form-field">
            <v-text-field
              v-model="tenantData.endereco"
              label="Endereço"
              outlined
              dense
            />
          </div>

          <v-alert
            type="info"
            text
            dense
            class="mb-6"
          >
            ℹ️ O Tenant será criado com:
            <ul class="mt-2">
              <li><strong>Razão Social:</strong> {{ tenantData.razaoSocial || '(não informado)' }}</li>
              <li><strong>CNPJ:</strong> {{ tenantData.cnpj || '(não informado)' }}</li>
              <li><strong>Setor:</strong> {{ tenantData.setor || '(não selecionado)' }}</li>
            </ul>
            <div class="mt-2">
              ⚠️ A <strong>Conta SaaS</strong> deve ser criada antes do Tenant.
            </div>
          </v-alert>

          <!-- Botões de ação centralizado -->
          <div class="button-container">
            <v-btn
              color="blue"
              rounded
              @click="salvarTenant"
              :disabled="!valid"
              class="action-button"
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar Tenant
            </v-btn>
          </div>
        </v-form>

        <!-- Painel de informações do endpoint -->
        <v-expansion-panels class="mt-6">
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon left color="blue">mdi-information</v-icon>
                <strong>Informações do Endpoint Backend</strong>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-simple-table>
                <tbody>
                  <tr>
                    <td class="font-weight-bold">Método:</td>
                    <td><v-chip small color="success">POST</v-chip></td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">URL:</td>
                    <td><code>/api/admin/bootstrap/tenant</code></td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Descrição:</td>
                    <td>Cria o tenant administrativo do sistema.</td>
                  </tr>
                </tbody>
              </v-simple-table>

              <v-divider class="my-4"></v-divider>

              <div class="font-weight-bold mb-2">Payload de exemplo:</div>
              <pre class="blue lighten-5 pa-3" style="border-radius: 4px; overflow-x: auto;">{{ JSON.stringify(tenantData, null, 2) }}</pre>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
    </v-card>

    <!-- Snackbar -->
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :timeout="3000"
      top
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'TenantSettings',
  
  data() {
    return {
      valid: false,
      salvando: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success',
      
      tenantData: {
        razaoSocial: '',
        nomeFantasia: '',
        cnpj: '',
        setor: '',
        telefone: '',
        email: '',
        endereco: '',
        website: '',
        porteEmpresa: ''
      },
      
      setores: [
        'Tecnologia',
        'Educação',
        'Saúde',
        'Financeiro',
        'Varejo',
        'Indústria',
        'Serviços',
        'Outro'
      ],
      
      portesEmpresa: [
        'Micro (1-9)',
        'Pequena (10-49)',
        'Média (50-249)',
        'Grande (250-999)',
        'Corporação (1000+)'
      ]
    }
  },
  
  mounted() {
    console.log('✅ TenantSettings montado com sucesso')
  },
  
  methods: {
    async salvarTenant() {
      if (!this.$refs.form.validate()) {
        return
      }
      
      this.salvando = true
      
      try {
        console.log('📤 Salvar Tenant:', this.tenantData)
        
        // Simulação de chamada ao backend (mock)
        await new Promise(resolve => setTimeout(resolve, 1000))
        
        this.snackbarText = '✅ Tenant salvo com sucesso! (mock)'
        this.snackbarColor = 'success'
        this.snackbar = true
        
        // Redirecionar após sucesso
        setTimeout(() => {
          this.$router.push('/settings')
        }, 2000)
      } catch (error) {
        console.error('❌ Erro:', error)
        this.snackbarText = 'Erro ao salvar tenant'
        this.snackbarColor = 'error'
        this.snackbar = true
      } finally {
        this.salvando = false
      }
    }
  }
}
</script>

<style scoped>
/* Container principal - estilo macOS */
#settings-tenant {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background: linear-gradient(135deg, #F5F5F7 0%, #f0f2f5 100%);
}

.theme--dark #settings-tenant {
  background: linear-gradient(135deg, #121212 0%, #1C1C1E 100%);
}

/* Header com botão de voltar */
.settings-header {
  position: fixed;
  top: 1rem;
  left: 1rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  z-index: 100;
}

.back-button {
  transition: all 0.2s ease;
}

.back-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.theme--dark .back-button:hover {
  background-color: rgba(255, 255, 255, 0.1);
}

/* Card centralizado - estilo macOS */
.settings-card {
  width: 100%;
  max-width: 600px;
  border-radius: 20px !important;
  background: white !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid rgba(0, 0, 0, 0.06) !important;
}

.theme--dark .settings-card {
  background: #1C1C1E !important;
  border-color: rgba(255, 255, 255, 0.1) !important;
}

/* Form container */
.form-container {
  width: 100%;
}

.form-field {
  margin-bottom: 1.5rem;
}

.form-field:last-of-type {
  margin-bottom: 0;
}

/* Button container centralizado */
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 2rem;
}

.action-button {
  min-width: 200px;
}

/* Code styling */
code {
  background-color: #f5f5f5;
  padding: 2px 6px;
  border-radius: 3px;
  font-family: 'Courier New', monospace;
  font-size: 0.85em;
}

.theme--dark code {
  background-color: rgba(255, 255, 255, 0.1);
  color: #e8e8e8;
}

pre {
  font-family: 'Courier New', monospace;
  font-size: 13px;
  border-radius: 8px;
  overflow-x: auto;
}

/* Responsive */
@media (max-width: 600px) {
  #settings-tenant {
    padding: 0.5rem;
  }

  .settings-card {
    max-width: 100%;
    border-radius: 16px !important;
  }

  .settings-header {
    position: static;
    margin-bottom: 2rem;
  }
}
</style>
